import React from 'react';
import cx from 'classnames';
import { ToastContainer, SLDSToast } from '@salesforce/design-system-react';

function Toast({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(ToastContainer, {
    className: "tds-notify-container"
  }, /*#__PURE__*/React.createElement(SLDSToast, Object.assign({}, props, {
    className: cx(className, "tds-notify_toast")
  })));
}
Toast.displayName = "Toast";
Toast.propTypes = SLDSToast.propTypes;
Toast.defaultProps = SLDSToast.defaultProps;

export { Toast as default };
